import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  IconButton,
  Avatar,
  AppBar,
  Toolbar,
  Button,
  Tab,
  Tabs,
  TextField,
  MenuItem,
  InputAdornment,
  Slider,
  Modal,
  TablePagination,
  InputLabel,
  Select,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Notifications, CalendarToday, Search } from "@mui/icons-material";
import "chart.js/auto";
import {
  AdminProductCard,
  CustomDataCard,
  SearchComponent,
  SnackBarComponent,
  VendorappBar,
} from "../../../components";
import { ListingCustomCard } from "../../../components";
import { Add } from "@mui/icons-material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ProductForm from "./productForm";
import Addbulkproducts from "./Addbulkproducts";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";

import { useDelete, useFetch, useFetchById } from "../../../hooks";
import { urls } from "../../../urls/urls";
import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { FormControl } from "@mui/joy";

const VendorProduct = ({ onBackScreenName }) => {
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [page, setPage] = useState(0);

  const loginToken = useSelector((state) => state.user.logintoken);
  const userDetails = useSelector((state) => state.user.userdetails);

  const userVtype = userDetails?.vtype;
  const userid = userDetails?.id;
  console.log("userVtype", userVtype);
  const [selectedTab, setSelectedTab] = useState(
    userVtype === "vendor" ? 0 : 1
  );
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const { id } = useSelector((state) => state.user.userdetails);
  console.log("vid", id);
  const [showForm, setShowForm] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const appStateToken = useSelector((state) => state.user);
  // const categories = ["Electronics", "Fashion", "Home Appliances"];
  const brands = ["Apple", "Samsung", "Sony"];
  const subcategories = ["Tv", "Laptops", "Ac"];
  const [priceRange, setPriceRange] = useState([10, 6500]);
  const [openBulkModal, setOpenBulkModal] = useState(false);
  const [customProduct, setCustomProduct] = useState(false);
  const [menuData, setMenuData] = useState();
  const [openProductModal, setOpenProductModal] = useState(false);
  const [allProdListingData, setAllProdListingData] = useState([]);
  const [allVendorProdData, setAllVendorProductsData] = useState([]);
  const [vendorCategoryDataFilter, setVendorCatgoryData] = useState([]);
  const [vListingCategory, setVlistinCategory] = useState([]);
  const [vendorSubCategoryDataFilter, setVendorSubCatgoryData] = useState([]);
  const [brandsDataFilter, setBrandsDataFilter] = useState([]);

  const {
    data: categoryListData,
    error: categoryListError,
    isLoading: categoryListLoading,
    fetchData: categoryListFetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllListing"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

    const {
    data: categoryListByIdData,
    error: categoryListByIdError,
    isLoading: categoryListByIdLoading,
    fetchDataById: categoryListByIdFetchData,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: vendorCategoryData,
    error: vendorCategoryError,
    isLoading: vendorCategoryLoading,
    fetchData: vendorCategoryFetchData,
  } = useFetch(BASE_URL_TEST + urls("getVCategories"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: subCategoryData,
    error: subCategoryError,
    fetchDataById: fetchSubCategory,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const [selectedVendor, setSelectedVendor] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const getInitialFormValues = () => ({
    category_id: selectedVendor ? selectedVendor.category_id : "",
    vendor_id: selectedVendor ? selectedVendor.vendor_id : "",
    vlisting_id: selectedVendor ? selectedVendor.vlisting_id : "",
    name: selectedVendor ? selectedVendor.name : "",
    price: selectedVendor ? selectedVendor.price : "",
    quantity: selectedVendor ? selectedVendor.quantity : "",
    self_delivery: selectedVendor ? selectedVendor.self_delivery : "",
    self_pickup: selectedVendor ? selectedVendor.self_pickup : "",
    description: selectedVendor ? selectedVendor.description : "",
    images: selectedVendor ? selectedVendor.images : "",
    vendor: selectedVendor ? selectedVendor.vendor : "",
    category_name: selectedVendor ? selectedVendor.category_name : "",
  });
  const [formValues, setFormValues] = useState(getInitialFormValues());
  // const [isEditing,setIsediting]=useState(false)
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    severity: "success", // Default severity
    message: "",
    position: { vertical: "top", horizontal: "center" },
  });

  const [searchValue, setSearchValue] = useState("");

  const {
    data: vProductsData,
    error: vProductsDataError,
    fetchDataById: fetchVProductsByID,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

    const {
      data: brandsData,
      isLoading: isBrandsLoading,
      error: brandsDataError,
      fetchData: fetchBrandData,
    } = useFetch(BASE_URL_TEST + urls("getAllBrands"), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });
  

    const {
      data: deleteProductData,
      isLoading: deleteProductLoading,
      error: deleteProductError,
      deleteData: fetchDeleteProductData,
    } = useDelete(BASE_URL_TEST, {
      method: "DELETE",
      headers: {
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    });

  useEffect(() => {
    console.log("useEffect vendorCategoryFetchData called");
  //  if (!userVtype === "vlistuser") {
  if( userVtype === "vendor"){
        vendorCategoryFetchData({ vendor_id: appStateToken.userdetails.id });
      fetchBrandData();
  }
     
   // } else {
   // }
  }, []);

   useEffect(() => {
      if (formValues["category_id"]) {
        const catByIdUrl = urls("findByCatId", formValues["category_id"]);
  
        fetchSubCategory(catByIdUrl);
       
      }
    }, [formValues["category_id"]]);

  // useEffect(() => {
  //   if (formValues["category_id"]) {
  //     const catByIdUrl = urls("findByCatId", selectedCategory);

  //     fetchSubCategory(catByIdUrl);
  //   }
  // }, [selectedCategory]);

  useEffect(() => {
    if (vendorCategoryError) {
    } else if (vendorCategoryData && vendorCategoryData.status == true) {
      setVendorCatgoryData(vendorCategoryData["data"]);
    }
  }, [vendorCategoryData, vendorCategoryError]);


  useEffect(() => {
    if (categoryListByIdError) {
    } else if (categoryListByIdData && categoryListByIdData.status == true) {
      setVlistinCategory(categoryListByIdData["data"]);
    }
  }, [categoryListByIdData, categoryListByIdError]);
  useEffect(() => {
     const findByUrl = urls("vListingCategoriesFindById", userid);
         categoryListByIdFetchData(findByUrl);
    categoryListFetchData();
  }, [userid]);

  useEffect(() => {
    if (subCategoryError) {
    } else if (subCategoryData && subCategoryData.status == true) {
      setVendorSubCatgoryData(subCategoryData["data"]);
    }
  }, [subCategoryData, subCategoryError]);

    useEffect(() => {
      if (error) {
      } else if (brandsData && brandsData["status"] === true) {
        // console.log("ribbonDataBadge",ribbonData['data'])
        // setRows(ribbonData['data'])
        // const ribbonOnly = brandsData["data"].filter(
        //   (item) => item.type === "badge"
        // );
        setBrandsDataFilter(brandsData["data"]);
      }
    }, [brandsData, error]);

  useEffect(() => {
    if (categoryListError) {
    } else if (categoryListData && categoryListData["status"] == true) {
      setCategories(categoryListData["data"]);
      console.log("datavlistcat", categoryListData["data"]);
    }
  }, [categoryListData, categoryListError]);

  useEffect(() => {
    console.log("useEffect called", userVtype);
    let vProductsById = "";

    // console.log("catByIdUrl",formValues)
    if (id && userVtype === "vendor") {
      vProductsById = urls("getAllVProducts", id);
      fetchVProductsByID(vProductsById);
    } else if (id && userVtype === "vlistuser") {
      vProductsById = urls("getAllVListingById", id);
      productListingFetchData(vProductsById);
    }
  }, []);

  const {
    data: productListingData,
    error: productListingError,
    fetchDataById: productListingFetchData,
  } = useFetchById(BASE_URL_TEST, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  console.log("appStateToken", appStateToken.userdetails.id);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

 

  useEffect(() => {
    if (vProductsDataError) {
    } else if (vProductsData && vProductsData["status"] == true) {
      setAllVendorProductsData(vProductsData["data"]);
    }
  }, [vProductsData, vProductsDataError]);


  
  useEffect(() => {
    if (vProductsDataError) {
    } else if (deleteProductData && deleteProductData["status"] == true) {
    //  setAllVendorProductsData(vProductsData["data"]);
    setSnackbarState({
        open: true,
        severity: "success",
        message: deleteProductData['message'] || "Product deleted successfully",
        position: { vertical: "top", horizontal: "center" }
    });
    handleFetchData();
  }}, [deleteProductData, deleteProductError]);

  useEffect(() => {
    if (productListingError) {
    } else if (productListingData && productListingData.status == true) {
      setAllProdListingData(productListingData["data"]);
    }
  }, [productListingData, productListingError]);

  const handleProductModalForm = () => {
    setOpenProductModal(false);
  };

  const handleOpenModal = (item) => {
    setOpenProductModal(true);
    setSelectedVendor(item);
    setIsEditing(true);
  };

  const handleAddListing = () => {
    console.log("called");
    setOpenProductModal(true);
    setIsEditing(false);
    setSelectedVendor(getInitialFormValues());
  };

  const handleFetchData = () => {
    setOpenProductModal(false);
    // productListingFetchData()
    setIsEditing(false);
    console.log("calleddkfd");

    let vProductsById = "";
    if (id && userVtype === "vendor") {
      vProductsById = urls("getAllVProducts", id);
      console.log("vProductsById if", vProductsById);
      fetchVProductsByID(vProductsById);
    } else if (id && userVtype === "vlistuser") {
      vProductsById = urls("getAllVListingById", id);
      console.log("vProductsById else", vProductsById);
      productListingFetchData(vProductsById);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (value) => {
    console.log("searchvalue", value);
    setSearchValue(value);
  };

  //   const filteredData = allProdListingData.filter(item => {

  //     const nameMatch = item.name.toLowerCase().includes(searchValue.toLowerCase());
  //     const descriptionMatch = item.description.toLowerCase().includes(searchValue.toLowerCase());
  //     return nameMatch && descriptionMatch  ;
  // });

  // const filteredData = searchValue
  //     ?
  //     allVendorProdData.filter(
  //       (item) =>
  //         item.name.toLowerCase().includes(searchValue.toLowerCase()) ||
  //         item.description.toLowerCase().includes(searchValue.toLowerCase()
  //       )
  //     )

  //     : allVendorProdData;

  // const filteredData = allProdListingData
  //   ? allProdListingData.filter((item) => {
  //       const itemPrice = Number(item.regularPrice);

  //       console.log("selectCat item", item, selectedCategory);
  //       const nameMatch = item.name
  //         .toLowerCase()
  //         .includes(searchValue.toLowerCase());
  //       const descriptionMatch = item.description
  //         .toLowerCase()
  //         .includes(searchValue.toLowerCase());

  //       // console.log("pricematch",itemPrice, priceRange[0], priceRange[1])

  //       const categoryMatch = selectedCategory
  //         ? item.category_name.toLowerCase() === selectedCategory.toLowerCase()
  //         : true;
  //       const brandMatch = selectedBrand
  //         ? item.brand_id === selectedBrand
  //         : true;

  //       console.log("selectCat", categoryMatch);
  //       console.log("selectCat", selectedCategory);

  //       const searchMatch = searchValue ? nameMatch || descriptionMatch : true;

  //       return searchMatch && categoryMatch && brandMatch;
  //     })
  //   : allVendorProdData?
  //   allVendorProdData.filter((item) => 
  //     {
  //       const itemPrice = Number(item.regularPrice);

  //       console.log("selectCat item", item.name);
  //       const nameMatch = item.name
  //         .toLowerCase()
  //         .includes(searchValue.toLowerCase());
  //       const descriptionMatch = item.description
  //         .toLowerCase()
  //         .includes(searchValue.toLowerCase());

  //       // console.log("pricematch",itemPrice, priceRange[0], priceRange[1])

  //       const categoryMatch = selectedCategory
  //         ? item.category_id === selectedCategory
  //         : true;
  //       const brandMatch = selectedBrand
  //         ? item.brand_id === selectedBrand
  //         : true;

  //       console.log("selectCat", categoryMatch);
  //       console.log("selectCat", selectedCategory);

  //       const searchMatch = searchValue ? nameMatch || descriptionMatch : true;

  //       return searchMatch && categoryMatch && brandMatch;
  //     }
  //   ): [];

  var filteredData = [];

const dataset = userVtype === "vendor" ? allVendorProdData : allProdListingData;
console.log("allProdListingData",dataset);

try {
if (dataset && Array.isArray(dataset)) {
  filteredData = dataset.filter((item) => {
    console.log("item loop",item);
      const searchText = (searchValue || "").toLowerCase();
      // Support both vendor product (`regularPrice`) and listing (`price`) payloads.
      const itemPrice = Number(item.regularPrice ?? item.price ?? 0);
      const normalizedCategoryId = String(item.category_id ?? "");
      const normalizedSubCategoryId = String(item.sub_cat_id ?? "");
      const normalizedBrandId = String(item.brand_id ?? "");

      const nameMatch = item.name?.toLowerCase().includes(searchText);
      const descriptionMatch = item.description?.toLowerCase().includes(searchText);
      const searchMatch = searchText ? nameMatch || descriptionMatch : true;
      const priceMatch =
        Number.isFinite(itemPrice) && itemPrice >= priceRange[0] && itemPrice <= priceRange[1];

    // Category check - adjust logic for vendor/admin
   const categoryMatch = selectedCategory
  ? userVtype === "vendor"
    ? normalizedCategoryId === String(selectedCategory)
    : item.category_name?.toLowerCase() ===
      String(selectedCategory).toLowerCase()
  : true;

      const subCategoryMatch = selectedSubCategory
  ? userVtype === "vendor"
    ? normalizedSubCategoryId === String(selectedSubCategory)
    : item.sub_category_name?.toLowerCase() ===
      String(selectedSubCategory).toLowerCase()
  : true;
    // Brand check
      const brandMatch = selectedBrand ? normalizedBrandId === String(selectedBrand) : true;

    console.log("Item:", item.name, "| Category Match:", categoryMatch , "| SubCategory Match:", item.sub_cat_id ,selectedSubCategory, "| Brand Match:", brandMatch, "| Search Match:", searchMatch);

      return searchMatch && categoryMatch;
  });
} else {
  console.warn("No dataset available for filtering");
}
} catch (error) {
  console.error("FILTER ERROR:", error);
}


  console.log("filteredData", filteredData);

  const handleBulkModalOpen = (openModal) => {
    setOpenBulkModal(openModal);
    fetchVProductsByID(urls("getAllVProducts", id));
  };

  const handleSnackbarClose = () => {
    setSnackbarState((prev) => ({ ...prev, open: false }));
  };

  const handleMenuClick = (data) => {
    console.log("menudata", data);

    setMenuData(data);
    setOpenBulkModal(true);
  };

  const handleEditing = (value) => {
    setIsEditing(value);
    setOpenProductModal(true);
  };

  const handleDeleteProduct = (prd_id) => {
    console.log("deleteprd_id", prd_id);
    if(userVtype === "vlistuser"){
      const deleteUrl = urls("deleteLProductById", prd_id);
     
    //  fetchDeleteProductData(deleteUrl);
    }else{
     const deleteUrl = urls("deleteVProductById", prd_id);
        
       fetchDeleteProductData(deleteUrl);
        }
      }
  

  console.log("selectedVendor", selectedVendor);
  return (
    <Box sx={{ display: "flex" }}>
      <SnackBarComponent
        open={snackbarState.open}
        onClose={handleSnackbarClose}
        severity={snackbarState.severity}
        message={snackbarState.message}
        position={snackbarState.position}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* <AppBar
          position="static"
          elevation={0}
          sx={{
            borderBottom: "1px solid #ddd",
            mb: 2,
            backgroundColor: "white",
            color: "black",
            borderRadius: "20px",
          }}
        >
          <Toolbar>
            <Typography variant="h6" noWrap sx={{ flexGrow: 1 }}>
              Good Morning, John!
            </Typography>

            <IconButton>
              <CalendarToday />
            </IconButton>
            <Typography variant="body1" sx={{ mx: 2 }}>
              28 July, 2024
            </Typography>
            <IconButton>
              <Notifications />
            </IconButton>
            <Avatar alt="Gn" src="/profile.webp" />
          </Toolbar>
        </AppBar> */}

        <VendorappBar
         title={userVtype === 'vlistuser' ? "Listing Management" : "Product Management"}
          onBackScreenName={handleScreeName}
        />

        {/* Tabs Section */}
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          sx={{
            // backgroundColor: "white",
            borderBottom: "1px solid #ddd",
            color: "black",
          }}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {/* <Tab label="Products" sx={{ textTransform: "none" }} />
          <Tab label="Listing" sx={{ textTransform: "none" }} /> */}
          {/* {userVtype === "vendor" && (
            <Tab label="Products" sx={{ textTransform: "none" }} />
          )}
          {userVtype === "vlistuser" && (
            <Tab label="Listing" sx={{ textTransform: "none" }} />
          )} */}
        </Tabs>

        <Box sx={{ flexGrow: 1 }}>
          {userVtype === "vendor" && selectedTab === 0 ? 
          (
            <>
              <Modal
                open={openBulkModal}
                onClose={() => setOpenBulkModal(false)}
              >
                <Box sx={modalStyle}>
                  {/* Close Button */}
                  <IconButton
                    sx={closeIconStyle}
                    onClick={() => setOpenBulkModal(false)}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Addbulkproducts
                    setModalOpen={handleBulkModalOpen}
                    isEditing={isEditing}
                    menuData={menuData}
                    isCustom={customProduct}
                    setCustomProduct={(value)=>{setCustomProduct(value)}}
                  />
                </Box>
              </Modal>

              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  p: 4,
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    justifyContent: "flex-end",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginY: 2,
                      gap: 2,
                    }}
                  >

                    <Button
                      variant="outlined"
                      sx={{ 
                        borderColor: "#3f51b5",
                        color: "#3f51b5",
                        "&:hover": {
                          backgroundColor: "rgba(63, 81, 181, 0.08)",
                          borderColor: "#3f51b5",
                        },
                      }}
                      startIcon={<FilterAltIcon />}
                      onClick={() => {
                        setSelectedCategory("");
                        setSelectedSubCategory("");
                        setSelectedBrand("");
                        setPriceRange([10, 6500]);
                        setSearchValue("");
                        setFormValues({
                          ...formValues,
                          category_id: "",
                          sub_cat_id: "",
                          brand_id: "",
                        });
                      }}
                    >
                      Reset Filter
                    </Button>

                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#3f51b5" }}
                      startIcon={<Add />}
                      onClick={() => {
                        setOpenBulkModal(true);
                        setIsEditing(false);
                      }}
                    >
                      ADD PRODUCT
                    </Button>

                     <Button
                      variant="contained"
                      sx={{ backgroundColor: "#2fc01fbe" }}
                      startIcon={<Add />}
                      onClick={() => {
                        setOpenBulkModal(true);
                        setIsEditing(false);
                        setCustomProduct(!customProduct);
                      }}
                    >
                      ADD CUSTOM PRODUCT
                    </Button>

                    
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: "10px" }}>

                  
                  <TextField
                    select
                    fullWidth
                    label="Category"
                    value={selectedCategory}
                       onChange={(e) => {
                        setSelectedCategory(e.target.value)
                        setSelectedSubCategory("");
                        setFormValues({
                          ...formValues,
                          category_id: e.target.value,
                          sub_cat_id: "",
                        });
                      }}
                  >
                   <MenuItem value="" sx={{color:"gray"}}>
                          {" -- Please Select a  Category --"}
                        </MenuItem>
                    {vendorCategoryDataFilter &&
                      Array.isArray(vendorCategoryDataFilter) &&
                      vendorCategoryDataFilter.map((item, index) => (
                        <MenuItem key={item.category_id} value={item.category_id}>
                          {item.name}
                        </MenuItem>
                      ))}
                        
                  </TextField>

                  <TextField
                    select
                    fullWidth
                    label="Sub Category"
                    value={selectedSubCategory}
                    style={{ marginBottom: "20px" }}
                        onChange={(e) => {
                        setSelectedSubCategory(e.target.value)
                        setFormValues({
                          ...formValues,
                          sub_cat_id: e.target.value,
                        });
                      }}
                  >
                      <MenuItem value="" sx={{color:"gray"}}>
                          {" -- Please Select a Sub Category --"}
                        </MenuItem>
                    {vendorSubCategoryDataFilter &&
                      Array.isArray(vendorSubCategoryDataFilter) &&
                      vendorSubCategoryDataFilter.map((item, index) => (
                        <MenuItem key={item.sub_cat_id} value={item.sub_cat_id}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </TextField>

                  <TextField select fullWidth label="Brands"
                       value={selectedBrand}
                       onChange={(e) => {
                        setSelectedBrand(e.target.value)
                        setFormValues({
                          ...formValues,
                          brand_id: e.target.value,
                        });
                      }}>
                          <MenuItem value="" sx={{color:"gray"}}>
                          {" -- Please Select a  Brand --"}
                        </MenuItem>
                    {brandsDataFilter.map((option) => (
                      <MenuItem key={option.brand_id} value={option.brand_id}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Box>
                <Box>
                  <Typography>Price Range</Typography>
                  <Slider
                    value={priceRange}
                    onChange={(event, newValue) => setPriceRange(newValue)}
                    valueLabelDisplay="auto"
                    min={10}
                    max={6500}
                    sx={{ marginBottom: "10px" }}
                  />

                  <Box style={{ marginBottom: "15px" }}>
                    Price Range: ₹{priceRange[0]} - ₹{priceRange[1]}
                  </Box>
                  <TextField
                    fullWidth
                    placeholder="Search by name"
                    value={searchValue}
                    onChange={(e) => handleSearch(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Box>
              </Box>

              {loading ? (
                <Typography variant="h6">Loading...</Typography>
              ) : error ? (
                <Typography variant="h6" color="error">
                  {error}
                </Typography>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    justifyContent: "space-between",
                    rowGap: 4,
                  }}
                >
                  {/* {allProdListingData && allProdListingData.length > 0 &&
                    allProdListingData.map((data, index) => (
                      <Box key={index}>
                        <Typography>{data.title}</Typography>{" "}
                      </Box>
                    ))} */}
                </Box>
              )}

              {/* Vendor Prodcut cards */}
              <Box
                sx={{
                  display: "grid",
                  //gridTemplateColumns: "repeat(3,  1fr)",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                  gap: "20px",
                  alignItems: "stretch",
                  justifyContent: "center",
                  padding: "20px",
                }}
              >
                {filteredData && filteredData.length > 0 ? (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data) => (
                      <Box
                        key={data.id}
                        sx={{
                          height: "100%", // Ensure consistent height
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <CustomDataCard
                          key={data.vlisting_id}
                          data={data}
                          onMenuClick={handleMenuClick}
                          isEditing={handleEditing}
                          onDeleteClick={(prd_id) => {handleDeleteProduct(prd_id)}}
                          status=""
                        />
                         
                      </Box>
                    ))
                ) : (
                  <Typography
                    sx={{
                      gridColumn: "1 / -1",
                      textAlign: "center",
                      padding: "40px",
                    }}
                  >
                    No Products Available
                  </Typography>
                )}
              </Box>
            </>
          ) : userVtype === "vlistuser" ? (
            <>
              {/* Modal for Vendor Listing Product Form */}
              <Modal
                onClose={() => setOpenProductModal(false)}
                open={openProductModal}
              >
                <Box sx={modalStyle}>
                  {/* Close Button */}
                  <IconButton
                    sx={closeIconStyle}
                    onClick={() => setOpenProductModal(false)}
                  >
                    <CloseIcon />
                  </IconButton>
                  <ProductForm
                    openModal={handleProductModalForm}
                    selecteditem={selectedVendor}
                    isEditing={isEditing}
                    fetchData={() => handleFetchData()}
                    menuData={menuData}
                  />
                </Box>
              </Modal>

              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  p: 4,
                  mt: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    justifyContent: "flex-end",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginY: 2,
                    }}
                  >
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#3f51b5" }}
                      startIcon={<Add />}
                      onClick={() => handleAddListing()}
                    >
                      ADD Listing
                    </Button>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", gap: "10px" }}>
                  {/* <TextField select fullWidth label="Category">
                      {categories&& Array.isArray(categories)?
                      categories.map((option) => (
                        <MenuItem key={option.id} value={option.name} onChange={(e) => setSelectedCategory(e.target.value)}>
                          {option.name}
                        </MenuItem>
                      )):
                      <MenuItem value="">No Categories Available</MenuItem>
                      }
                    </TextField>
                    */}
                  <FormControl fullWidth sx={{ mb: 2,width:'50%',height:'30%' }} >
                    <InputLabel id="category-label">Category</InputLabel>
                    <Select
                      labelId="category-label"
                      value={selectedCategory}
                      onChange={(e) => setSelectedCategory(e.target.value)} 
                    >
                    

                         {vListingCategory?.listCategories &&
                        vListingCategory.listCategories.map((category) => (
                          <MenuItem key={category?.category_id} value={category?.name}>
                            {category?.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                  <SearchComponent
                    placeholder={"Search by "}
                    handleChange={handleSearch}
                  />
                </Box>
              </Box>


              

              {loading ? (
                <Typography variant="h6">Loading...</Typography>
              ) : error ? (
                <Typography variant="h6" color="error">
                  {error}
                </Typography>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 2,
                    justifyContent: "space-between",
                    rowGap: 4,
                  }}
                >
                  {/* {card.length > 0 &&
                    card.map((data, index) => (
                      <Box key={index}>
                        <Typography>{data.title}</Typography>{" "}
                      </Box>
                    ))} */}
                </Box>
              )}

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3,  1fr)",
                  gap: "0px",
                  justifyContent: "center",
                  padding: "20px",
                }}
              >
                {
                filteredData && filteredData.length > 0 ? (
                  filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((data) => (
                      <Box
                        key={data?.vlisting_id ? data?.vlisting_id : data.id}
                        sx={{
                          height: "100%", // Ensure consistent height
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {/* for Listing login  */}
                        <AdminProductCard
                          // title={data.name}
                          // summary={data.description}
                          // price={data.regularPrice}
                          // sales={data.sku}
                          // remaining={data.holescount}
                          // images={data?.images || []}
                          data={data}
                          onMenuClick={handleMenuClick}
                          onDeleteClick={(prd_id) => {
                            console.log("clicked delete for listing",prd_id);
                            handleDeleteProduct(prd_id);
                          }}
                          isEditing={() => {
                            handleEditing(true);
                            handleOpenModal(true);
                          }}
                        />
                      </Box>
                    ))
                )
                 : (
                  <Typography
                    sx={{
                      gridColumn: "1 / -1",
                      textAlign: "center",
                      padding: "40px",
                    }}
                  >
                    No Products Availables
                  </Typography>
                )}
              </Box>

              {/* <TablePagination
                rowsPerPageOptions={[6, 10, 12, 25]}
                component="div"
                count={
                  filteredData && filteredData.length ? filteredData.length : 0
                }
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
              /> */}

              <TablePagination
  rowsPerPageOptions={[9]}    // force only 9 per page
  component="div"
  count={filteredData.length}
  rowsPerPage={rowsPerPage}
  page={page}
  onPageChange={handlePageChange}
  onRowsPerPageChange={handleRowsPerPageChange}  // disable change
/>
            </>
          ) : null}
          {/* <TablePagination
  rowsPerPageOptions={[9]}    // force only 9 per page
  component="div"
  count={filteredData.length}
  rowsPerPage={rowsPerPage}
  page={page}
  onPageChange={handlePageChange}
  onRowsPerPageChange={handleRowsPerPageChange}  // disable change
/> */}
        </Box>
      </Box>
    </Box>
  );
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  maxWidth: "100%",
  height: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  overflowY: "scroll",
  zposition: "relative",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  scrollbarWidth: "none",
};
const closeIconStyle = {
  position: "absolute",
  top: 8,
  right: 8,
  zIndex: 10,
};

export default VendorProduct;
